import moment from 'moment';

/* eslint-disable no-sequences */
/* eslint-disable @typescript-eslint/no-unused-expressions */
const I = [
  {
    day: [1, 1],
    name: 'Anul Nou'
  },
  {
    day: [2, 1],
    name: 'A doua zi de Anul Nou'
  },
  {
    day: [24, 1],
    name: 'Ziua Unirii'
  },
  {
    day: [1, 5],
    name: 'Ziua Muncii'
  },
  {
    day: [1, 6],
    name: 'Ziua Copilului'
  },
  {
    day: [15, 8],
    name: 'Adormirea Maicii Domnului'
  },
  {
    day: [30, 11],
    name: 'Sfântul Andrei'
  },
  {
    day: [1, 12],
    name: 'Ziua Națională a României'
  },
  {
    day: [25, 12],
    name: 'Ziua de Crăciun'
  },
  {
    day: [26, 12],
    name: 'A doua zi de Crăciun'
  }
];

const Q = function (e: any) {
  var t = e.isoWeekday();
  [6, 7].includes(t) && e.add(8 - t, 'days');
};
const Y = function (e: any) {
  var t = e.month() + 1,
    a = e.date(),
    n = I.find(function (e) {
      return e.day[0] === a && e.day[1] === t;
    });
  return void 0 !== n;
};
const W = function (e: any) {
  var t = moment();
  t.date(4), t.month(3), t.year(e);
  var a = ((e % 19) * 19 + 15) % 30;
  t.add(a, 'days');
  var n = ((e % 4) * 2 + (e % 7) * 4 + 6 * a + 6) % 7;
  return (
    t.add(n, 'days'),
    {
      day: t.date(),
      month: t.month() + 1,
      momentDate: t
    }
  );
};
const E = function (e: any) {
  var t = e.month(),
    a = e.date(),
    n = e.year(),
    s = W(n);
  return (
    s.momentDate.subtract(2, 'days'),
    n >= 2018 && s.momentDate.month() === t && s.momentDate.date() === a
  );
};

const Z = function (e: any) {
  var t = e.month(),
    a = e.date(),
    n = W(e.year()),
    s = n.momentDate.clone();
  s.add(1, 'day');
  var r = n.month === t + 1 && n.day === a,
    i = s.month() === t && s.date() === a;
  return r || i;
};

const U = function (e: any) {
  var t = e.month(),
    a = e.date(),
    n = W(e.year()),
    s = e.clone();
  s.month(n.month - 1), s.date(n.day), s.add(49, 'days');
  var r = [s.date(), s.date() + 1];
  return r.includes(a) && s.month() === t;
};
const G = function (e: any) {
  Q(e);
  var t = [Y(e), E(e), Z(e), U(e)];
  t.some(function (e) {
    return e;
  }) && (e.add(1, 'days'), G(e));
};

export const q = function (e: any, t: any, x: any, y: any, z: any) {
  var a =
      arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 'days',
    n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
    s = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
    r = e.clone();
  r.startOf('day');
  var i = Number(t);
  return (
    'days' === a && (n ? (i -= 1) : r.add(1, a)),
    'hours' === a && r.add(1, 'day'),
    r.add(i, a),
    'months' === a && s && r.add(15, 'days'),
    G(r),
    r
  );
};

export const endOfTerm = (
  selectedDuration: string,
  applyDurationModifier: any,
  termStartDate: any,
  termCounter: any
) => {
  var e = 'days' === selectedDuration && applyDurationModifier,
    t = 'months' === selectedDuration && applyDurationModifier,
    a = termStartDate,
    n = selectedDuration,
    s = termCounter,
    r = q(a, s, n, e, t);
  // ,i = 'LL';
  // return (
  //   'hours' === selectedDuration && (i = 'LLL'), r.locale('ro'), r.format(i)
  // );
  return r;
};
